import { createAction } from '@ngrx/store';

import { BreadcrumbItem } from 'ish-core/models/breadcrumb-item/breadcrumb-item.interface';
import { payload } from 'ish-core/utils/ngrx-creators';

export const setBreadcrumbData = createAction(
  '[Viewconf Internal] Set Breadcrumb Data',
  payload<{ breadcrumbData: BreadcrumbItem[] }>()
);

export const setStickyHeader = createAction('[Viewconf] Set Sticky Header', payload<{ sticky: boolean }>());

/* DIAS Customisation Start */

//It maintains the height of the Relative header in the state.
export const setHeaderHeight = createAction(
  '[Header] Set Header Height',
  payload<{
    headerHeight: number;
  }>()
);
export const setSearchBoxActive = createAction(
  '[Search Box] Set Search Active Status',
  payload<{
    searchBoxActive: boolean;
  }>()
);

export const setIsTransparentHeader = createAction(
  '[Header] Set Is Transparent Header',
  payload<{
    isTransparentHeader: boolean;
  }>()
);

// export const maintainStickyHeaderState = createAction('[Maintain header state]');
/* DIAS Customisation End */
